/* eslint-disable indent */
import React from 'react';
import { HugerteEditor, Tickbox } from 'components/FormControl';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
export default function ResearchCapacityTable({
  control,
  setValue,
  // eslint-disable-next-line no-unused-vars
  getValues,
  errors,
  disabled,
  // eslint-disable-next-line no-unused-vars
  projectType,
}) {
  const { t } = useTranslation();
  const handleCheck = (name, value) => {
    const token = name.split('.');
    const [, key] = token;
    let otherKeys = [];
    switch (key) {
      case 'isQualified':
        otherKeys = ['isNotQualified'];
        break;
      case 'isNotQualified':
        otherKeys = ['isQualified'];
        break;
      default:
        otherKeys = [];
        break;
    }
    if (otherKeys?.length && value === true) {
      otherKeys.forEach((otherKey) => {
        setValue(`researchCapacity.${otherKey}`, false);
      });
    }
  };
  return (
    <div className="form-table">
      <h5>{t('council.m01b.a.a3.label')}</h5>
      <table>
        <thead>
          <tr>
            <th style={{ width: '80%' }}>{t('council.m01b.a.a3.table.header')}</th>
            <th style={{ width: '20%' }}>{t('council.m01b.evaluates.header')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="m-2" style={{ whiteSpace: 'pre-wrap' }}>
                {t('council.m01b-2024.a.a3.table.criteriaA')}
              </div>
            </td>
            <td>
              <div className="flex my-2">
                <Tickbox
                  icon="pi pi-check"
                  name="researchCapacity.isQualified"
                  control={control}
                  errors={errors}
                  onCustomCheck={handleCheck}
                  disabled={disabled}
                />
                <span className="ml-1">{t('council.m01b.evaluates.qualified')}</span>
              </div>
              <div className="flex my-2">
                <Tickbox
                  icon="pi pi-check"
                  name="researchCapacity.isNotQualified"
                  control={control}
                  errors={errors}
                  onCustomCheck={handleCheck}
                  disabled={disabled}
                />
                <span className="ml-1">{t('council.m01b.evaluates.notQualified')}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <div className="mt-1">
                <span className=" text-xl font-bold">{t('council.m01b.review')}</span>
                <HugerteEditor
                  name="researchCapacityReview"
                  control={control}
                  errors={errors}
                  style={{ height: 'auto', minHeight: '200px' }}
                  disabled={disabled}
                  readOnly={disabled}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ResearchCapacityTable.propTypes = {
  control: PropTypes.shape({}).isRequired,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  projectType: PropTypes.string,
};

ResearchCapacityTable.defaultProps = {
  disabled: false,
  projectType: '',
};
